import { Pipe, PipeTransform } from '@angular/core';
import { CalendarSource } from '@app/modules/calendar/data/calendar-source.interface';

@Pipe({
  standalone: false,
  name: 'friendlySourceLabel',
})
export class FriendlySourceLabelPipe implements PipeTransform {
  transform(sourceChannel: CalendarSource['source']): string {
    switch (sourceChannel) {
      case 'airbnb-official':
      case 'airbnb':
        return 'airbnb';

      case 'api':
        return 'api';

      case 'booking':
        return 'booking.com';

      case 'homeaway':
        return 'vrbo';

      case 'agoda':
        return 'agoda';

      case 'override':
        return 'reservation sync';

      case 'manual':
        return 'manual edit';

      case 'multiple':
        return 'multiple';

      case 'none':
        return 'none';

      case 'turnover_days':
        return 'turnover days';

      case 'booking_lead_time':
        return 'advance notice';

      case 'rolling_availability':
        return 'availability window';

      case 'restricted_checkin':
        return 'restricted checkin';

      case 'restricted_checkout':
        return 'restricted checkout';

      default:
        break;
    }

    //We may send a vendor name so just return the value from the API
    return sourceChannel;
  }
}
